import React from 'react';

import {SiteArea} from '~/src/utilities/constants/navigation';

interface Settings {
    siteArea: typeof SiteArea[keyof typeof SiteArea];
    isWebView: boolean;
    isFromLegacy: boolean;
    enableServerRequest: boolean;
}

const SettingsContext = React.createContext<Settings>({
    siteArea: SiteArea.NEWS,
    isWebView: false,
    isFromLegacy: false,
    enableServerRequest: false
});

interface SettingsProps extends Settings {
    children?: React.ReactNode;
}

const SettingsProvider = ({siteArea = SiteArea.NEWS, isWebView = false, isFromLegacy = false, enableServerRequest = false, children}: SettingsProps) => {
    const settings = {siteArea, isWebView, isFromLegacy, enableServerRequest};

    return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

interface ContextProps {
    context: any;
}

interface ContextHoc extends React.ComponentClass<ContextProps> {
    getInitialProps?: () => void;
}

const withSettingsContext = (WrappedComponent: ContextHoc) => {
    const SettingsConsumer = ({context, ...props}: ContextProps) => (
        <SettingsContext.Consumer>{(settings) => <WrappedComponent context={{...context, settings}} {...props} />}</SettingsContext.Consumer>
    );
    SettingsConsumer.getInitialProps = WrappedComponent.getInitialProps;
    return SettingsConsumer;
};

export {SettingsContext, withSettingsContext};

export default SettingsProvider;
